import sentrySetup from './sentry';
import analytics from './analytics';

export default () => {
  sentrySetup();
  analytics();
};
